// semeia-disable-reexport
import { sortBy } from "./sort";

/**
 * A decorator to force a field to be provided in a child class.
 * TODO : to delete with Rhumatowise
 */
export function abstractField(object, property: string) {
  return {
    get() {
      throw `The property '${property}' should be overriden for the class '${this.constructor.name}' because it extends the abstract class '${object.constructor.name}'.`;
    }
  };
}

export function activeJournalEvents(...args) {
  const descriptor = args[2];
  return {
    ...descriptor,
    get() {
      return descriptor.get
        .call(this)
        .filter(je => !je.isArchived)
        .sort(sortBy("occurredAt"));
    }
  };
}
